import React from 'react'
import cx from 'classnames'
import * as Icon from '@manychat/icons'

import { TagProps } from './interfaces'

import cm from './Tag.module.css'

export const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  (
    {
      value,
      removable = true,
      className,
      isEditing = false,
      editingValue = '',
      editingRef,
      variant,
      disabled = false,
      onRemove,
      onDoubleClick,
      onKeyDown,
      onValueChange,
      onBlur,
    },
    ref,
  ) => {
    const showRemoveButton = removable && !isEditing && !disabled
    const inputSize = 1 + (editingValue?.length ?? 0)

    return (
      <span
        ref={ref}
        className={cx(
          cm.tag,
          {
            [cm.selected]: isEditing,
            [cm.disabled]: disabled,
            [cm.filled]: variant === 'filled',
          },
          className,
        )}
        onDoubleClick={!disabled ? onDoubleClick : undefined}
        onKeyDown={!disabled ? onKeyDown : undefined}
        tabIndex={disabled ? -1 : 0}
      >
        {isEditing ? (
          <input
            ref={editingRef}
            type="text"
            className={cm.tag__input}
            size={inputSize}
            value={editingValue}
            onChange={(event) => onValueChange?.(event.target.value)}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />
        ) : (
          <span className={cm.tag__text}>{value}</span>
        )}
        {showRemoveButton && (
          <button
            className={cm.tag__removeButton}
            onClick={() => onRemove?.(value)}
            type="button"
            aria-label={`Remove ${value}`}
          >
            <Icon.Close size={16} />
          </button>
        )}
      </span>
    )
  },
)

Tag.displayName = 'Tag'
